(() => {
  const init = (scope = document) => scope.querySelectorAll('.fv-menu-panel--mega').forEach(panel => {
    if (panel.dataset.previewReady) return;
    const previews = [...panel.querySelectorAll('[data-nav-preview-product]')];
    if (!previews.length) return;
    panel.dataset.previewReady = 'true';
    panel.querySelectorAll('a.fv-menu-link').forEach(link => {
      const path = new URL(link.href, location.href).pathname;
      const target = previews.find(p => p.dataset.navPreviewProduct === path);
      if (!target) return;
      const media = target.querySelector('.fv-home-product-card__media');
      if (media) link.href = media.href;
      let version = 0;
      const show = async () => {
        const request = ++version;
        previews.forEach(p => { p.hidden = p !== target; });
        const image = media?.querySelector('.fv-home-product-card__image--secondary');
        if (!image) return;
        image.loading = 'eager';
        try { await image.decode(); if (request !== version || target.hidden) return;
          media.dataset.secondaryReady = 'true'; media.classList.add('is-nav-hover');
        } catch {}
      };
      const leave = () => { version++; media?.classList.remove('is-nav-hover'); };
      link.addEventListener('pointerenter', show); link.addEventListener('focus', show);
      link.addEventListener('pointerleave', leave); link.addEventListener('blur', leave);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
